<div class="flex flex-col">
    <p class="!m-0 text-md text-medium">{{exerciseForm.controls.name.value}}</p>
    <p class="text-xs text-medium text-gray-500 !m-0">
        {{getConfigTitle()}}
    </p>
</div>
